import logo from '../assets/logo_3.png';
const ColorOptions = ({ setSelectedColor, selectedColor, colors }) => {

    return (
        <>
            <div>
                <img
                    src={logo}
                    alt="Surgery Journey Logo"
                    className="header-logo default-icon"
                    style={{
                        borderRadius: '1000px',
                        height: '100px',
                        width: '100px',
                        border: '1px solid #2c3e50',
                        backgroundColor: selectedColor,
                    }}
                />
            </div>
            <div className="color-picker">
                <label>Choose a background color:</label>
                <div className="color-options">
                    {colors.map((color) => (
                        <button
                            key={color.value}
                            type="button"
                            className={`color-option ${selectedColor === color.value ? 'selected' : ''}`}
                            style={{ backgroundColor: color.value }}
                            onClick={() => setSelectedColor(color.value)}
                            title={color.label}
                        />
                    ))}
                </div>
            </div>
        </>
    )
}

export default ColorOptions;